import { Input, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";

const { Text } = Typography;

const cases = [
  { key: "1", customer: "Joseph Kariuki", subject: "Transfer dispute", channel: "Phone", owner: "Support Desk", priority: "Critical", status: "Escalated" },
  { key: "2", customer: "Mary Atieno", subject: "Deposit refund", channel: "Email", owner: "Resolutions", priority: "High", status: "Open" },
  { key: "3", customer: "Peter Wachira", subject: "Inspection clarification", channel: "WhatsApp", owner: "Dealer Success", priority: "Normal", status: "Pending buyer" },
];

export default function WheelsCustomersScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Wheels"
        title="Buyer Support"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All statuses" },
                { value: "open", label: "Open" },
                { value: "escalated", label: "Escalated" },
                { value: "pending", label: "Pending buyer" },
              ]}
              style={{ width: 150 }}
            />
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All channels" },
                { value: "phone", label: "Phone" },
                { value: "email", label: "Email" },
                { value: "whatsapp", label: "WhatsApp" },
              ]}
              style={{ width: 150 }}
            />
            <Input.Search placeholder="Search customer or case" style={{ width: 220 }} />
          </div>
        }
      >
        <Text type="secondary">
          Buyer support, disputes, and lifecycle issues are marketplace-specific and should stay in the Wheels module.
        </Text>
      </GlassPanel>

      <GlassPanel title="Open Cases">
        <Table
          rowKey="key"
          size="small"
          pagination={{ pageSize: 10, showSizeChanger: false }}
          dataSource={cases}
          columns={[
            { title: "Customer", dataIndex: "customer" },
            { title: "Subject", dataIndex: "subject" },
            { title: "Channel", dataIndex: "channel" },
            { title: "Owner", dataIndex: "owner" },
            {
              title: "Priority",
              dataIndex: "priority",
              render: (value: string) => <Tag color={value === "Critical" ? "error" : value === "High" ? "warning" : "default"}>{value}</Tag>,
            },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => <Tag color={value === "Escalated" ? "error" : value === "Open" ? "processing" : "default"}>{value}</Tag>,
            },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
